// This enum is for Medium Attachment GQL endpoint
export enum MediumableType {
  PROJECT = 'Project',
  CASTING_ROLE = 'Casting Role',
  PROFILE = 'Profile',
  AUDITION = 'Audition',
  AUDITION_SCHEDULE = 'AuditionSchedule',
}
